import request from '@/utils/request'
import requestPython from '@/utils/request_python'

export function loginByUsername (username, password) {
  const data = {
    username,
    password
  }
  return request({
    url: '/u/a/' + data.username + '/' + data.password,
    method: 'get'
  })
}

export function logout () {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo () {
  return request({
    url: '/u/ui',
    method: 'get'
  })
}

export function tokenMicros (username, password) {
  return requestPython({
    url: `user/login`,
    method: 'post',
    params: {
    username,
    password
    }
  });
}